import { baseConfig } from "@/core/config";
import { assertIsDefined } from "@/core/utils/typeHelpers";

export const fetchNews = async () => {
  assertIsDefined(baseConfig.VITE_APP_NEWS_ENDPOINT);
  return await fetch(baseConfig.VITE_APP_NEWS_ENDPOINT);
};
